import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api, { fmtDate, money } from "@/lib/api";
import { Loading, Empty } from "@/components/site/ui";
import StatusBadge from "@/components/StatusBadge";
import WeatherPanel from "@/components/WeatherPanel";

export default function PortalHome() {
  const [res, setRes] = useState(null);
  const [card, setCard] = useState(null);
  useEffect(() => {
    api.get("/portal/reservations").then((r) => setRes(r.data)).catch(() => setRes([]));
    api.get("/portal/membership-card").then((r) => setCard(r.data)).catch(() => {});
  }, []);

  const upcoming = (res || []).filter((r) => !["Cancelled", "Checked Out", "Declined", "Archived"].includes(r.status));

  return (
    <div className="space-y-8">
      <WeatherPanel variant="card" />
      {card && (
        <div className="rounded-xl p-6 relative overflow-hidden glass" style={{ borderColor: `${card.color}66` }} data-testid="portal-membership-card">
          <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full blur-3xl opacity-30" style={{ background: card.color }} />
          <div className="flex justify-between items-start relative z-10">
            <div>
              <p className="text-[10px] tracking-label uppercase text-muted-foreground">The D · Member</p>
              <p className="font-serif text-2xl mt-1">{card.member_name}</p>
              <p className="text-sm mt-3" style={{ color: card.color }}>{card.level}</p>
              <p className="text-xs text-muted-foreground mt-1">No. {card.member_number}</p>
            </div>
            <img src={card.qr} alt="member qr" className="h-20 w-20 rounded" />
          </div>
        </div>
      )}

      <div>
        <div className="flex justify-between items-center mb-4">
          <h2 className="font-serif text-2xl">Upcoming</h2>
          <Link to="/portal/reservations" className="text-sm text-gold flex items-center gap-1">All reservations <ArrowRight size={14} /></Link>
        </div>
        {res === null ? <Loading /> : upcoming.length === 0 ? (
          <Empty title="No upcoming reservations" text="Ready for a night at The D?" />
        ) : (
          <div className="space-y-3">
            {upcoming.slice(0, 4).map((r) => (
              <Link key={r.id} to={`/portal/reservations/${r.id}`} data-testid={`portal-res-${r.id}`}
                className="glass rounded-lg p-5 flex justify-between items-center hover:glow-gold transition-shadow">
                <div>
                  <p className="font-serif text-xl">{r.experience_title}</p>
                  <p className="text-xs text-muted-foreground mt-1">{r.confirmation_number} · {fmtDate(r.arrival_date)} → {fmtDate(r.departure_date)}</p>
                </div>
                <div className="text-right space-y-2">
                  <StatusBadge status={r.status} />
                  <p className="text-xs text-muted-foreground">{r.checkin_status}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
